import angular from 'angular';
import template from './template.html';
import './style.scss';

export class LinkedInSummary {}

export const linkedinSummaryConfiguration = {
    template,
    bindings: {
        summary: '<',
        recruiter: '<',
        onClose: '&',
        onDone: '&',
    },
    controller: LinkedInSummary,
    controllerAs: 'linkedInSummaryCtrl',
};

angular.module('TALENYA-FE').component('linkedinSummary', linkedinSummaryConfiguration);